// extracted by mini-css-extract-plugin
export default {"container":"BurgerLinks_container__ER+v5","list":"BurgerLinks_list__LP4g6","link":"BurgerLinks_link__jmFLC"};